import { createApi, type TokenStore } from "@elektr/shared";

const KEY_ACCESS = "ep.access";
const KEY_REFRESH = "ep.refresh";

function safe<T>(fn: () => T, fallback: T): T {
  try {
    return fn();
  } catch {
    return fallback; // private rejim yoki localStorage bloklangan
  }
}

export const tokens: TokenStore = {
  getAccess: () => safe(() => localStorage.getItem(KEY_ACCESS), null),
  getRefresh: () => safe(() => localStorage.getItem(KEY_REFRESH), null),
  set(access, refresh) {
    safe(() => {
      localStorage.setItem(KEY_ACCESS, access);
      if (refresh) localStorage.setItem(KEY_REFRESH, refresh);
    }, undefined);
  },
  clear() {
    safe(() => {
      localStorage.removeItem(KEY_ACCESS);
      localStorage.removeItem(KEY_REFRESH);
    }, undefined);
  },
};

export const AUTH_LOST_EVENT = "ep:auth-lost";

export const api = createApi({
  baseUrl: (import.meta.env.VITE_API_BASE as string | undefined) ?? window.location.origin,
  tokens,
  onAuthLost: () => window.dispatchEvent(new Event(AUTH_LOST_EVENT)),
});

export { ApiError, errorMessage, isConflict, unwrap } from "@elektr/shared";
